// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1plsc","footer":"styles_footer__2lWpU"};